import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography, Tooltip, CircularProgress, FormGroup, Checkbox, Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { backendDateFormat, fieldDateFormat } from "../../../../constants";
import { useParams } from "react-router";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus, getTextFieldRows } from "../../../../utils";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getConstantTypesApi } from "../../../../shared_elements/actionCreators";
import { ButtonLoader } from "../../../../shared_elements/components";
import { editReDeliveryConditionApi, getClauseAPi } from "../apiService";
import { trackActivity } from "../../../../utils/mixpanel";
import { regexConstants } from "../../../../constants/regEx";

const EditRedelivery = ({ editRedelivery, onToggleModal, getResponseBack }) => {
    const params = useParams();
    const dispatch = useDispatch()
    const { constantTypes, leaseBasicDetails } = useSelector((state) => state.leases);
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(editRedelivery?.data);
    const [error, setError] = useState({});
    const [clauseData, setClauseData] = useState([]);
    const [isDropDownLoading, setIsDropDownLoading] = useState(false);

    useEffect(() => {
        const payload = {
            constant_types: ["operating_region"]
        };
        dispatch(getConstantTypesApi(payload));
        getConditionClauseData();
    }, []);

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const getConditionClauseData = () => {
        setIsDropDownLoading(true)
        globalGetService(getClauseAPi(params))
            .then(response => {
                setIsDropDownLoading(false)
                if (checkApiStatus(response)) {
                    let responseClause = [];
                    const data = response?.data.data?.list;
                    data?.map((item) => {
                        responseClause.push({ id: item?.id, name: item?.name })
                    });
                    setClauseData(responseClause || []);
                }
            })
    }

    const validateDate = (value, fieldLabel, required = false) => {
        if (!value && required) return `Please enter ${fieldLabel}`;
        if (!value) return "";
        const leaseStartDate = moment(leaseBasicDetails?.start_date);
        const leaseEndDate = moment(leaseBasicDetails?.end_date);
        const date = moment(value);

        if (!date.isValid()) {
            return `Please enter valid Date`;
        }
        if (!leaseStartDate?.isValid() || !leaseEndDate?.isValid()) {
            return "";
        }
        return date.isBetween(leaseStartDate, leaseEndDate, "day", "[]")
            ? ""
            : `${fieldLabel} must be within the lease period`;
    };
    const onEditReDeliveryCondition = () => {
        const validationInputs = {
            actual_redelivery_date: validateDate(data?.actual_redelivery_date, 'Return Date Actual'),
            contractual_redelivery_date: validateDate(data?.contractual_redelivery_date, 'Return Date Contractual'),
            estimated_redelivery_date: validateDate(data?.estimated_redelivery_date, 'Return Date Estimated'),
            // redelivery_location: data?.redelivery_location ? "" : "Please enter Return Location",
            // redelivery_terms: data?.redelivery_terms ? "" : "Please enter Terms",
            // redelivery_asset_conditions_for_contract_id: data?.redelivery_asset_conditions_for_contract_id?.id ? "" : "Please select Clause",
            redelivery_location: data?.redelivery_location ? "" : "Please enter Return Location",
        };

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            const payload = {
                ...data,
                contractual_lease_expiry_c_check: data?.contractual_lease_expiry_c_check,
                contractual_return_original_engine: data?.contractual_return_original_engine,
                contractual_operating_region: data?.contractual_operating_region,
                // redelivery_asset_conditions_for_contract_id: data?.redelivery_asset_conditions_for_contract_id?.id ? data?.redelivery_asset_conditions_for_contract_id?.id : null,
            }
            globalPutService(editReDeliveryConditionApi(params), payload).then(async (response) => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    onToggleModal()
                    getResponseBack();
                    setLoading(false);
                    trackActivity('Item Edited', { page_title: `Edit Return Condition`, success_msg: response?.data?.message, item_slug: params?.leaseSlug, payload: data, response: response?.data })
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Edited', { page_title: `Edit Return Condition`, error_msg: response?.data?.message, item_slug: params?.leaseSlug, payload: data, response: response?.data })
                }
            });
        } else {
            setError(validationInputs);
            trackActivity(`Item Edited`, { page_title: `Edit Return Condition`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Edit Return Condition`, page_type: page_type, })
    }

    return (
        <Dialog
            aria-labelledby="customized-dialog-title"
            className='add-lease-dialog'
            maxWidth='md'
            fullWidth
            open={editRedelivery.modal}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                <Typography sx={{ marginLeft: '10px' }}>Edit Return Condition</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Return Date Contractual"
                                value={data?.contractual_redelivery_date ? moment(data.contractual_redelivery_date) : null}
                                onChange={(data) => {
                                    const isValid = moment(data)?.isValid();
                                    onFieldChange("contractual_redelivery_date", data ? moment(data).format(backendDateFormat) : null);
                                    if (isValid) {
                                        onRestErrorKey("contractual_redelivery_date");
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        error: error.contractual_redelivery_date || false,
                                        helperText: error.contractual_redelivery_date || '',
                                        onFocus: () => onRestErrorKey("contractual_redelivery_date")
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("date", null);
                                            onRestErrorKey("date");
                                        }
                                    },
                                }}
                                shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Return Date Actual"
                                value={data?.actual_redelivery_date ? moment(data.actual_redelivery_date) : null}
                                onChange={(data) => {
                                    const isValid = moment(data)?.isValid();
                                    onFieldChange("actual_redelivery_date", data ? moment(data).format(backendDateFormat) : null);
                                    if (isValid) {
                                        onRestErrorKey("actual_redelivery_date");
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        error: error.actual_redelivery_date || false,
                                        helperText: error.actual_redelivery_date || '',
                                        onFocus: () => onRestErrorKey("actual_redelivery_date")
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("date", null);
                                            onRestErrorKey("date");
                                        }
                                    },
                                }}
                                shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}

                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Return Date Estimated"
                                value={data?.estimated_redelivery_date ? moment(data.estimated_redelivery_date) : null}
                                onChange={(data) => {
                                    const isValid = moment(data)?.isValid();
                                    onFieldChange("estimated_redelivery_date", data ? moment(data).format(backendDateFormat) : null);
                                    if (isValid) {
                                        onRestErrorKey("estimated_redelivery_date");
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        error: error.estimated_redelivery_date || false,
                                        helperText: error.estimated_redelivery_date || '',
                                        onFocus: () => onRestErrorKey("estimated_redelivery_date")
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("date", null);
                                            onRestErrorKey("date");
                                        }
                                    },
                                }}
                                shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}

                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            label="Return Location"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            readOnly={true}
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                            value={data?.redelivery_location || ""}
                            onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("redelivery_location", e.target?.value.trimStart()) : e.preventDefault()}
                            onFocus={() => onRestErrorKey("redelivery_location")}
                            error={Boolean(error.redelivery_location)}
                            helperText={error.redelivery_location || (data?.redelivery_location?.length > 25 ? "Maximum 25 characters allowed" : "")}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            label="Remarks"
                            variant="outlined"
                            readOnly={true}
                            size="small"
                            margin="normal"
                            slotProps={{ inputLabel: { shrink: true } }}
                            sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                            value={data?.redelivery_remarks || ""}
                            onChange={(e) => {
                                onFieldChange("redelivery_remarks", e.target.value.trimStart())
                            }}
                            error={Boolean(error.redelivery_remarks)}
                            helperText={error.redelivery_remarks}
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <FormGroup className='disabled-checkbox-wrapper'>
                            <Box className="check-item-div">
                                <Checkbox checked={data?.redelivery_serviceable === true ? true : false} onChange={(e) => onFieldChange('redelivery_serviceable', e.target.checked)} />
                                <Typography className="check-item-span" fontSize='14px'>Serviceable</Typography>
                            </Box>
                        </FormGroup>
                    </Grid>
                    <Typography color="primary" sx={{ width: "100%" }}>Contractual Details</Typography>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            label="Fit Operational Region"
                            onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("contractual_operating_region", e.target.value.trimStart()) : e.preventDefault() }}
                            value={data?.contractual_operating_region}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            label="Livery"
                            onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("contractual_livery", e.target.value.trimStart()) : e.preventDefault() }}
                            value={data?.contractual_livery}
                            error={error?.contractual_livery}
                            helperText={error?.contractual_livery}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            label="Lease Expiry C-Check"
                            onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("contractual_lease_expiry_c_check", e.target.value.trimStart()) : e.preventDefault() }}
                            value={data?.contractual_lease_expiry_c_check}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={["Yes", "No"]}
                            isOptionEqualToValue={(option, value) => option === value}
                            value={["Yes", "No"]?.find((option) => option === String(data?.contractual_return_original_engine)) || null}
                            onChange={(e, value) => onFieldChange("contractual_return_original_engine", value || "")}
                            onFocus={() => onRestErrorKey("contractual_return_original_engine")}
                            renderInput={(params) => {
                                const selectedLabel = params?.inputProps?.value || "";
                                return (
                                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                        <TextField
                                            {...params}
                                            label="Return with Original Engine"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.contractual_return_original_engine)}
                                            helperText={error.contractual_return_original_engine}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                        />
                                    </Tooltip>)
                            }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="contractual_location"
                            onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("contractual_location", e.target.value.trimStart()) : e.preventDefault() }}
                            value={data?.contractual_location}
                            error={error?.contractual_location}
                            helperText={error?.contractual_location}
                            label="Location"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, input: { maxLength: 50 } }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="contractual_country"
                            onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("contractual_country", e.target.value.trimStart()) : e.preventDefault()}
                            value={data?.contractual_country}
                            error={error?.contractual_country}
                            helperText={error?.contractual_country}
                            label="Country"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true }, }}
                        />
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            id="premature_redelivery"
                            label="Premature Redelivery"
                            value={data?.premature_redelivery}
                            onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("premature_redelivery", e.target.value.trimStart()) : e.preventDefault()}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            id="contractual_comments"
                            onChange={(e) => { onFieldChange("contractual_comments", e.target.value.trimStart()) }}
                            value={data?.contractual_comments}
                            error={error?.contractual_comments}
                            helperText={error?.contractual_comments}
                            label="Comments"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline
                            rows={3}
                            sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ marginRight: '15px' }}>
                <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" color="primary" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>Cancel</Button>
                <Button variant="contained" size="small" onClick={() => { handleItemClicked('Save Button'); onEditReDeliveryCondition(); }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
            </DialogActions>
        </Dialog>
    )
}
export default EditRedelivery;